/**
 * This is the sce routes configuration.
 * Only configure routes in this file.
 * @memberOf sce Module
 * @namespace sce Routes
 */
import twofaSceTemplate from './2fa.sce.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf sce Module.sce Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	/* Create the sce state and assign the template and controller. */

	$stateProvider
		.state('login.2fa.sce', {
			url: '/register/sce',
			template: twofaSceTemplate,
			controller: 'twofaSceController',
			controllerAs: 'vm'
		});

}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/sce/2fa.sce.route.js